import React from 'react';
// import {Link} from 'react-router-dom';

const Footer = () => {

  return (
    <footer className="blog-footer">
    {/* <p className="text-center">
        <a href="#">Back to top</a>
      </p> */}
      <p className="text-center text-muted">Risha Lab              
        <a
          className="preserve mx-1"
          href={"https://iittp.ac.in/"}
        >
        IIT Tirupati
        </a></p>
    </footer>
  )
}

export default Footer;